export const NOTO_GUJARATI_BASE64 = "AAEAAAALAIAAAwAwT1MvM...";
